import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/features-actions";

const featuresReducer = (state = INITIAL_STATE.features, action) => {
  switch (action.type) {
    case TYPES.SET_FEATURES: {
      return action.features;
    }

    default:
      return state;
  }
};

export default featuresReducer;
